export default typeof window !== 'undefined' && typeof window.document !== 'undefined';